import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight, MessageCircle, Phone, Star, Users, ShieldCheck, Award } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { HERO_SLIDES, COMPANY } from '../../mock';

export default function Hero() {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx(i => (i + 1) % HERO_SLIDES.length), 6000);
    return () => clearInterval(t);
  }, []);

  const go = (d) => setIdx(i => (i + d + HERO_SLIDES.length) % HERO_SLIDES.length);
  const slide = HERO_SLIDES[idx];

  return (
    <section className="relative h-[92vh] min-h-[500px] sm:min-h-[620px] max-h-[820px] w-full overflow-hidden">
      {/* Slides */}
      {HERO_SLIDES.map((s, i) => (
        <div key={s.id} className={`absolute inset-0 transition-opacity duration-[1200ms] ease-out ${i === idx ? 'opacity-100' : 'opacity-0'}`}>
          <img src={s.image} alt={s.title} className={`absolute inset-0 w-full h-full object-cover ${i === idx ? 'scale-105' : 'scale-100'} transition-transform duration-[8000ms] ease-out`} />
          <div className="absolute inset-0 bg-gradient-to-r from-brand-blue/85 via-brand-blue/55 to-transparent" />
          <div className="absolute inset-0 bg-gradient-to-t from-brand-blue/70 via-transparent to-transparent" />
        </div>
      ))}

      {/* Content */}
      <div className="relative h-full max-w-7xl mx-auto px-6 lg:px-8 flex flex-col justify-center">
        <div className="max-w-2xl text-white">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md border border-white/20 px-3 py-1.5 rounded-full text-[12px] font-medium mb-5 animate-fade-up">
            Trusted by 3+ Lakh Indian Travelers Since 2015
          </div>
          <h1 key={slide.id} className="font-poppins font-extrabold text-[42px] sm:text-[52px] lg:text-[64px] leading-[1.05] tracking-tight animate-fade-up">
            {slide.title}
          </h1>
          <p className="mt-5 text-white/85 text-lg lg:text-xl max-w-xl animate-fade-up" style={{animationDelay: '120ms'}}>
            {slide.subtitle}<br/>
            <span className="text-white/65 text-base">Also All India & International tours - fully customizable.</span>
          </p>

          <div className="mt-8 flex flex-wrap gap-3 animate-fade-up" style={{animationDelay: '240ms'}}>
            <a href={`https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent('Hi Mountains Chain Travel! 👋\n\nI\'m interested in planning a trip with you.\n\nPlease share:\n- Available tour packages\n- Popular destinations\n- Pricing & offers\n\nThank you!')}`} target="_blank" rel="noreferrer">
              <Button className="bg-brand-orange hover:bg-brand-orangeDark text-white text-[15px] font-semibold rounded-xl h-12 px-6 btn-glow shadow-glow-orange">
                <MessageCircle size={18} className="mr-2" /> Get Quote on WhatsApp
              </Button>
            </a>
            <a href={`tel:${COMPANY.phone}`}>
              <Button variant="outline" className="bg-white/10 backdrop-blur-md border-white/40 text-white hover:bg-white hover:text-brand-blue text-[15px] font-semibold rounded-xl h-12 px-6">
                <Phone size={17} className="mr-2" /> Call Now
              </Button>
            </a>
          </div>

          {/* Mini trust badges */}
          <div className="mt-8 flex flex-wrap gap-x-6 gap-y-3 text-[13px] text-white/85 animate-fade-up" style={{animationDelay: '360ms'}}>
            <div className="flex items-center gap-2"><ShieldCheck size={16} className="text-brand-orange" /> Govt. Approved DMC</div>
            <div className="flex items-center gap-2"><Star size={16} className="text-brand-orange fill-brand-orange" /> 2000+ 5★ Reviews</div>
            <div className="flex items-center gap-2"><Users size={16} className="text-brand-orange" /> 3 Lakh+ Happy Travelers</div>
            <div className="flex items-center gap-2"><Award size={16} className="text-brand-orange" /> 24x7 Support</div>
          </div>
        </div>

        {/* Controls */}
        <div className="absolute right-6 lg:right-10 bottom-10 flex items-center gap-3">
          <button onClick={() => go(-1)} className="w-11 h-11 rounded-full border border-white/40 text-white hover:bg-white hover:text-brand-blue transition-colors flex items-center justify-center" aria-label="prev"><ChevronLeft size={20} /></button>
          <div className="text-white/70 text-sm font-medium">{String(idx + 1).padStart(2, '0')} / {String(HERO_SLIDES.length).padStart(2, '0')}</div>
          <button onClick={() => go(1)} className="w-11 h-11 rounded-full border border-white/40 text-white hover:bg-white hover:text-brand-blue transition-colors flex items-center justify-center" aria-label="next"><ChevronRight size={20} /></button>
        </div>
      </div>
    </section>
  );
}
